import { render, staticRenderFns } from "./GiftCodeWidgetSlider.vue?vue&type=template&id=bdb0985e"
import script from "./GiftCodeWidgetSlider.vue?vue&type=script&lang=js"
export * from "./GiftCodeWidgetSlider.vue?vue&type=script&lang=js"
import style0 from "./GiftCodeWidgetSlider.vue?vue&type=style&index=0&id=bdb0985e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports